export default __webpack_public_path__ + "static/1_21-38e014dfa1f2b14e5d0614d1c124940f.png";